<script lang="ts">
    import { getI18n } from '~/stores/i18n';

    const i18n = getI18n();

    const columns = [
        {
            id: 'badge',
        },
        {
            id: 'track',
            labelKey: 'ASE.Web.MusicClassical.Library.Tracks.Headers.Track',
        },
        {
            id: 'composer-work',
            labelKey:
                'ASE.Web.MusicClassical.Library.Tracks.Headers.ComposerWork',
            hideBelowSmall: true,
        },
        {
            id: 'artist',
            labelKey: 'ASE.Web.MusicClassical.Library.Tracks.Headers.Artist',
            hideBelowSmall: true,
        },
        {
            id: 'time',
            labelKey: 'ASE.Web.MusicClassical.Library.Tracks.Headers.Time',
        },
    ];
</script>

<div class="library-track-header-container">
    <div
        class="library-track library-track--header"
        role="row"
        data-testid="library-track--header"
    >
        {#each columns as column (column.id)}
            <div
                role="columnheader"
                class="library-track-header-column library-track__{column.id}"
                class:hidden={column.hideBelowSmall}
            >
                <span
                    class="library-track__{column.id}-text"
                    data-testid={`library-track__${column.id}-text`}
                >
                    {column.labelKey ? $i18n.t(column.labelKey) : ''}
                </span>
            </div>
        {/each}
    </div>
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/sasskit-stylekit/ac-sasskit-config';

    .library-track-header-container {
        border-top: 1px solid var(--labelDivider);
        margin-inline: var(--bodyGutter);

        &::after {
            content: '';
            overflow-y: scroll;
            visibility: hidden;
        }
    }

    .library-track--header {
        width: 100%;
        height: var(--libraryTrackHeaderHeight, 27px);
        padding-top: 16px;
        padding-bottom: 9px;
        display: grid;
        font: var(--callout-emphasized);
        color: var(--systemSecondary);

        // Defined in Tracks.svelte, shared with TrackListItem
        grid-template-columns: var(--libraryTrackColumns);
    }

    .library-track-header-column {
        padding-inline-start: 9px;
        position: relative;
        z-index: var(--z-default);

        // First column is unlabeled prefix column.
        // Second column: track name
        &:nth-child(2) {
            padding-inline-start: 7px;
        }

        // All columns after second column
        &:nth-child(n + 3)::before {
            content: '';
            width: 1px;
            background-color: var(--labelDivider);
            position: absolute;
            inset-block: 0;
            inset-inline-start: 0;
        }

        @media (--range-xsmall-down) {
            &.hidden {
                display: none;
            }
        }
    }
</style>
